import React, { createContext, useContext, useEffect, useState } from "react";

// Global section-nav state. Pages register two optional pieces:
//   sectionTabs — the page's own primary tab bar (e.g. PWHL Standings/Schedule/…)
//   subtabs     — the active section's controls (stage/season/position/filters…)
// Both are surfaced inside the bottom "Sections" drawer (mobile/tablet) AND the
// collapsible desktop section bar.
const MobileNavContext = createContext({
    sectionTabs: null, setSectionTabs: () => {},
    subtabs: null, setSubtabs: () => {},
    drawerRequest: null, openDrawer: () => {},
});

export function MobileNavProvider({ children }) {
    const [sectionTabs, setSectionTabs] = useState(null);
    const [subtabs, setSubtabs] = useState(null);
    const [drawerRequest, setDrawerRequest] = useState(null);
    const openDrawer = (key) => setDrawerRequest({ key, ts: Date.now() });
    return (
        <MobileNavContext.Provider value={{ sectionTabs, setSectionTabs, subtabs, setSubtabs, drawerRequest, openDrawer }}>
            {children}
        </MobileNavContext.Provider>
    );
}

export const useMobileNav = () => useContext(MobileNavContext);

// Register the active section's controls as the current page's "Sections" content.
export function useMobileSubtabs(node, deps = []) {
    const { setSubtabs } = useMobileNav();
    useEffect(() => {
        setSubtabs(() => node);
        return () => setSubtabs(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

// Register the page's own primary tab bar (separate slot so a child section's
// subtabs don't overwrite the parent page's tabs).
export function useMobilePageTabs(node, deps = []) {
    const { setSectionTabs } = useMobileNav();
    useEffect(() => {
        setSectionTabs(() => node);
        return () => setSectionTabs(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
